import {Component, OnInit, ViewChild} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {LanguageModel} from '../../../../translation/translation.models';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {LanguageService} from '../../../../translation/Services/language.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {TranslateService} from '@ngx-translate/core';
import {TranslationFormlyService} from '../../../Services/translation.formly.service';
import {environment} from '../../../../../environments/environment';
import {FabricCollection} from '../../../Models/FabricCollection';
import {FabricCollectionService} from '../../../Services/fabric-collection.service';

@Component({
  selector: 'app-manage-fabric-collection',
  templateUrl: './manage-fabric-collection.component.html',
  styleUrls: ['./manage-fabric-collection.component.scss']
})
export class ManageFabricCollectionComponent implements OnInit {
  public classicBox;
  public lastValue = {fabricCollection: new FabricCollection()};
  public enableSave = true;
  form = new UntypedFormGroup({});
  model: any = {};
  public fabricCollectionId: number;
  public translations = [];
  public languageMap = {};
  public languages: LanguageModel[] = [];
  private translationFields = ['name'];
  public isEdit = false;
  options: FormlyFormOptions = {};
  @ViewChild('classicForm', {static: false}) child;

  constructor(
    private languageService: LanguageService,
    private route: ActivatedRoute,
    public helper: Helper,
    private translate: TranslateService,
    private translationFormlyService: TranslationFormlyService,
    private fabricCollectionService: FabricCollectionService,
    private router: Router,
  ) {
  }

  ngOnInit() {

    this.languageService.list().subscribe(lang_resp => {
      this.languages = lang_resp.languages;
      this.languages.forEach(lang => {
        this.languageMap[lang.locale] = lang.name;
      });

      this.route.params.subscribe(params => {
        new Promise((resolve, reject) => {
          if (Helper.isDefined(params['id'])) {
            this.fabricCollectionId = params['id'];
            this.isEdit = true;

            this.fabricCollectionService.getFabricCollectionItem(this.fabricCollectionId).subscribe(resp => {
              resolve(resp);
            });


          } else {
            resolve(new FabricCollection());
          }
        }).then(fabricCollection => {
          this.lastValue.fabricCollection = (<FabricCollection>fabricCollection);
        }).then(() => {
          this.lastValue.fabricCollection.translations =
            TranslationFormlyService.prepareTranslationFields(this.translationFields, this.lastValue.fabricCollection.translations, this.languages);
        }).then(() => {
          this.classicBox = <FormlyFieldConfig>[];
          Object.keys(this.lastValue.fabricCollection.translations).forEach((field) => {
            const row = {
              fieldGroupClassName: 'row',
              key: 'fabricCollection.translations',
              fieldGroup: []
            };

            Object.entries(this.lastValue.fabricCollection.translations[field]).forEach((t) => {
              row.fieldGroup.push(
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: field + '[' + t[0] + ']',
                  templateOptions: {
                    label: this.languageMap[t[0]],
                    required: true,
                    maxLength: environment.maxStringLength,

                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      required: this.translate.instant('errors.required'),
                      maxlength: (error, field: FormlyFieldConfig) =>
                        this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                    },
                  },
                }
              );
            });

            this.classicBox.push(
              {
                className: 'section-label',
                template: '<div><strong>' + this.translate.instant('doctrine.fabric-collection.name') + '</strong></div><hr />',
              }
            );

            this.classicBox.push(row);
          });
          this.classicBox.push(
            {
              className: 'section-label',
              template: '<div><strong>' + this.translate.instant('doctrine.fabric-collection.price') + ':</strong></div><hr />',
            },
            {
              fieldGroupClassName: 'row',
              key: 'fabricCollection',
              fieldGroup: [
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'dealerPrice',
                  templateOptions: {
                    label: this.translate.instant('doctrine.fabric-collection.dealer_price'),
                    addonLeft: {
                      text: this.translate.instant('global.currency_sign'),
                    },
                    required: true,
                    pattern: '^\\d{0,8}\\.\\d{1,4}$|^\\d{0,11}$',
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      required: this.translate.instant('errors.required'),
                      maxlength: (error, field: FormlyFieldConfig) =>
                        this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                    },
                  },
                },
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'customerPrice',
                  templateOptions: {
                    label: this.translate.instant('doctrine.fabric-collection.customer_price'),
                    addonLeft: {
                      text: this.translate.instant('global.currency_sign'),
                    },
                    required: true,
                    pattern: '^\\d{0,8}\\.\\d{1,4}$|^\\d{0,11}$',
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      required: this.translate.instant('errors.required'),
                      maxlength: (error, field: FormlyFieldConfig) =>
                        this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                    },
                  },
                },
              ],
            },
            {
              className: 'section-label',
              template: '<div><strong>' + this.translate.instant('admin.fabric-collection.other') + ':</strong></div><hr />',
            },
            {
              fieldGroupClassName: 'row',
              key: 'fabricCollection',
              fieldGroup: [
                {
                  className: 'col-3 ',
                  type: 'ng-select',
                  key: 'status',
                  defaultValue: true,
                  templateOptions: {
                    label: this.translate.instant('doctrine.fabric-collection.status'),
                    required: true,
                    options: [
                      {label: this.translate.instant('global.active'), value: true},
                      {label: this.translate.instant('global.inactive'), value: false},
                    ],
                  },
                },
                // checkbox
                {
                  className: 'col-3 pt-4',
                  type: 'checkbox',
                  key: 'discounted',
                  templateOptions: {
                    label: this.translate.instant('admin.backoffice.fabric_collection.discontinued'),
                  },
                }
              ],
            },
          );
        });
      });
    });
  }


  enableButton(event) {
    this.enableSave = event;
  }

  submitItem(next: boolean) {
    if (next) {
      const fabricCollection = JSON.parse(JSON.stringify(this.lastValue));
      delete fabricCollection.fabricCollection.id;
      delete fabricCollection.fabricCollection.fabrics;
      delete fabricCollection.fabricCollection.position;
      delete fabricCollection.fabricCollection.isCustom;
      fabricCollection.fabricCollection.translations =
        TranslationFormlyService.reorganizeTranslations(this.translationFields, fabricCollection.fabricCollection.translations);
      this.fabricCollectionService.manageFabricCollection(fabricCollection, this.isEdit, this.fabricCollectionId).subscribe((resp) => {
        window.history.back();
      });
    } else {
      window.history.back();
    }

  }

}
